export enum ReviewRAGChangeChipValues {
    RAGChanges = 1,
    Review = 2,
}
